module.exports = __webpack_public_path__ + "img/btn-bg2.bcacfa5e.png";